<template>
    <div class="animated fadeInLeft authentication-bg">
        <div class="account-pages">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-5">
                        <div class="card mt-4">
                            <!-- Logo -->
                            <div
                                class="card-header pt-3 pb-3 text-center bg-primary"
                            >
                                <span class="text-white font-weight-bold h2">{{
                                    companyName
                                }}</span>
                            </div>
                            <div class="card-body p-4">
                                <div class="text-center w-75 m-auto">
                                    <h4
                                        class="text-dark-50 text-center mt-0 font-weight-bold"
                                    >
                                        Reset Password
                                    </h4>
                                    <p class="text-muted mb-4">
                                        Enter your email address and we'll send
                                        you an email with instructions to reset
                                        your password.
                                    </p>
                                </div>
                                <form>
                                    <div class="form-group mb-3 mt-3">
                                        <ValidationProvider
                                            rules="required|email"
                                            v-slot="{ errors }"
                                            name="email"
                                        >
                                            <eb-input
                                                lable="Email address*"
                                                id="emailaddress"
                                                placeholder="Enter your email"
                                                v-model="email"
                                                type="email"
                                                name="email"
                                                validation="required|email"
                                            ></eb-input>
                                            <span
                                                class="validate-error"
                                                style="color: red"
                                                >{{ errors[0] }}</span
                                            >
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group mb-3 mt-3">
                                        <eb-select
                                            id="sl"
                                            type="text"
                                            v-model="role"
                                            :options="selectOption"
                                            placeholder="Account type"
                                        ></eb-select>
                                    </div>
                                    <div
                                        class="form-group mb-3 mt-3"
                                        v-if="
                                            role !== 'Admin' &&
                                            role !== 'Tenant'
                                        "
                                    >
                                        <eb-select
                                            id="tenant"
                                            type="text"
                                            v-model="selectedTenant"
                                            label="name"
                                            :options="tenantList"
                                            placeholder="Select Tenant"
                                        ></eb-select>
                                    </div>
                                    <div class="form-group mb-4 text-center">
                                        <button
                                            class="btn btn-primary btn-lg"
                                            @click.prevent="sendEmail"
                                        >
                                            Send OTP
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <!--end card-body-->
                        </div>
                        <!-- end card -->
                        <div class="row mt-3 mb-4">
                            <div class="col-12 text-center">
                                <p class="text-muted">
                                    Back to
                                    <router-link to="/login">
                                        <a class="text-muted ml-1">
                                            <b>Log In</b>
                                        </a>
                                    </router-link>
                                </p>
                            </div>
                            <!-- end col -->
                        </div>
                        <!-- end row -->
                    </div>
                    <!--end col -->
                </div>
                <!-- end row -->
            </div>
            <!--  end container -->
        </div>
        <!-- end page -->
    </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import ebInput from "@/components/FormElements/Input.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import "vue-select/dist/vue-select.css";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
    name: "RecoveryPassword",
    components: {
        ebInput,
        ebSelect,
        ValidationProvider,
    },
    data() {
        return {
            email: "",
            role: "",
            selectedTenant: "",
            selectOption: [
                "Admin",
                "Tenant",
                "Seller",
                "Distributor",
                "Dealer",
                "Manufacturer",
            ],
            companyName:
                JSON.parse(sessionStorage.getItem("companyName")) ||
                "FASTFORGE",
        };
    },
    computed: {
        tenantList() {
            let listdata = this.$store.getters["tenant/GetTenantLiteList"];
            listdata.map((object) => {
                object["name"] = object.company ? object.company.name : "";
            });
            return listdata;
        },
    },
    mounted() {
        this.GetTenantList();
    },
    methods: {
        ...mapActions({
            GetTenantList: "tenant/fetchTenantsListLite",
        }),
        sendEmail() {
            if (this.role !== "Admin" && this.role !== "Tenant") {
                this.role = "Partner";
            }
            sessionStorage.setItem("userRole", this.role);
            if (this.role === "Partner") {
                sessionStorage.setItem("nipige:key", this.selectedTenant._id);
            }

            this.$store
                .dispatch("passwordReset/sendPasswordResetEmail", {
                    email: this.email,
                    userType: this.role,
                })
                .then((data) => {
                    this.$swal(data);
                    if (data.success) {
                        this.$router.push({
                            name: "resetpasswordemail",
                        });
                    }
                });
        },
    },
};
</script>
<style scoped>
.authentication-bg {
    background-image: url("/img/bg-pattern-light.svg");
    background-size: cover;
    background-position: center;
}
.bg-primary {
    background-color: var(--primary) !important;
}
.card-header:first-child {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    padding: 30px 5px !important;
}
.btn-primary {
    background: var(--secondary) !important;
    border: none !important;
    border-radius: 2px !important;
    box-shadow: 0px 1px 5px 1px var(--secondary) !important;
}
.form-control {
    height: calc(1.5em + 0.75rem + 10px) !important;
}
.card-body {
    margin: 15px !important;
}
.card {
    border: none !important;
    box-shadow: 0px 1px 5px 1px #cdcfea !important;
}
</style>
